/**
 * @Description:
 * @Author: jiaxiuc
 * @Date: 2024-04-02
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-11
 */
export default {
  固定值: 'Fixed Value',
  主对象配置: 'Main Object Configuration',
  子对象配置: 'Child Object Configuration',
  字段参数重复: 'Field Parameter Duplication',
  合同模板: 'Contract Template',
  映射规则: 'Mapping Rules',
  数据源接口: 'Generate Data Source Interface',
  开始同步: 'Start Synchronization',
  默认视图: 'Default View',
  列表同步接口: 'Option Synchronization Interface',
  '将烽火某个对象满足条件的数据同步到飞书合同，飞书合同用下拉单选字段进行承接': 'Synchronize the data of a certain object in the beacon fire that meets the conditions to the Feishu contract, which is then taken over using the dropdown radio field',
  数据回填接口: 'Data Backfill Interface',
  接口名称: 'Interface Name',
  接口地址: 'Interface Address',
  请输入接口名称进行搜索: 'Please enter the interface name to search',
  监听的合同阶段: 'Monitored Contract Stage',
  监听的合同范围: 'Monitored Contract Scope',
  请选择监听的合同阶段: 'Please select the monitored contract stage',
  监听的业务类型: 'Monitored Business Type',
  请选择监听的业务类型: 'Please select the monitored business type',
  确认: 'Confirm',
  字段参数: 'Field Parameters',
  字段名: 'Field Name',
  枚举值: 'Enumeration Value',
  补充: 'Supplement',
  设置枚举值: 'Set Enumeration Value',
  批量处理枚举值: 'Batch Process Enumeration Values',
  批量处理: 'Batch Process',
  根节点: 'Root Node',
  请输入字段参数: 'Please enter field parameters',
  请输入字段名: 'Please enter field name',
  请输入接口名称: 'Please enter interface name',
  参数名: 'Parameter Name',
  请求参数: 'Request Parameters',
  新建参数: 'New Parameter',
  回填参数: 'Backfill Parameter',
  回填字段: 'Backfill Field',
  请选择回填参数: 'Please select backfill parameter',
  请选择回填字段: 'Please select backfill field',
  请添加回填字段: 'Please add a backfill field',
  label对应字段: 'Label Corresponding Field',
  请选择label对应字段: 'Please select the label corresponding field',
  value对应字段: 'Value Corresponding Field',
  添加子节点: 'Add Child Node',
  '枚举值,说明:请使用英文逗号分隔': 'Enumeration Value, Description: Please use English commas to separate',
  配置同步规则: 'Configure Synchronization Rules',
  '或（or）': 'Or (or)',
  合同创建时: 'When contract is created',
  审批发起时: 'When approval is initiated',
  审批完成时: 'When approval is completed',
  盖章发起时: 'When stamping is initiated',
  归档发起时: 'When archiving is initiated',
  归档完成时: 'When archiving is completed',
  节点通过时: 'When node is approved',
  节点拒绝时: 'When node is rejected',
  节点撤回时: 'When node is withdrawn',
  合同重新提交时: 'When contract is resubmitted',
  合同作废时: 'When contract is voided',
  合同申请: 'Contract Application',
  '合同变更（补充协议）': 'Contract Change (Supplementary Agreement)',
  合同终止: 'Contract Termination',
  合同组申请: 'Contract Group Application',
  合同信息修改: 'Contract Information Modification',
  合同原始信息: 'Original Contract Information',
  合同到期: 'Contract Expiration',
  '筛选 ·': 'Filter ·',
  满足以下筛选条件: 'Meet the following filtering criteria',
  全选: 'Select All',
  飞书合同: 'Feishu Contract',
  数据ID: 'Data ID',
  开启配置: 'Enable Configuration',
  已开启配置: 'Configuration Enabled',
  '格式：枚举值,说明,枚举值,说明....，请注意使用英文逗号分隔': 'Format: Enum Value, Description, Enum Value, Description.... Please use English commas for separation',
  '开启配置后，不支持关闭配置。如您不再同步飞书合同相关信息，只需关闭同步开关即可': 'After enabling the configuration, it is not supported to disable it. If you no longer wish to synchronize Feishu contract-related information, simply turn off the synchronization switch.',
  '开启配置后，烽火将自动同步飞书合同接口标准字段': 'After enabling the configuration, Fenghuo will automatically synchronize standard Feishu contract interface fields',
  '开启配置后，请先检查【合同模板】、【映射规则】、【同步规则】进行设置，再开始同步飞书合同': "After enabling the configuration, please first check and set up the 'Contract Template', 'Mapping Rules', and 'Synchronization Rules' before starting to synchronize Feishu contracts.",
  请选择主对象主键: 'Please select the primary key of the main object.',
  '飞书合同某个字段变化时，调用该接口，获取烽火相关单据信息': 'When a certain field in Feishu contract changes, call this interface to retrieve relevant documents from Fenghuo.',
  飞书合同数据同步插件: 'Feishu Contract Data Synchronization Plugin',
  '飞书合同以数据ID的方式进行请求时，将烽火对应单据信息进行回填': 'When requesting the Feishu contract in the form of data ID, backfill the corresponding document information of the beacon fire',
  完善说明: 'Complete instructions',
  完善枚举值: 'Improve enumeration values',
  自动获取字段: 'Automatically obtain fields',
  飞书合同编号: 'Feishu Contract ID',
  请输入飞书合同编号: 'Please enter the Feishu Contract ID',
  取消: 'Cancel',
  合同模板详情: 'Contract template details',
  新增: 'Add',
  任务名称: 'Task Name',
  请输入任务名称: 'Please enter the task name',
  从烽火字段: 'From the beacon field',
  请选择: 'Please select',
  到飞书合同字段: 'To Feishu Contract Fields',
  请输入飞书合同分组名称: 'Please enter the name of the Feishu contract group',
  请输入飞书合同字段名称: 'Please enter the field name of the Feishu contract',
  启用状态: 'Enabling status',
  保存: 'Preserve',
  '请确认：停用后该任务不再生效': 'Please confirm: After deactivation, this task will no longer take effect ！',
  '请选择烽火对象/字段': 'Please select the beacon object/field',
  请选择飞书合同字段: 'Please select the Feishu contract field'
};
